<template>
  <material-card
    :title="$t('components.contributionscontrol.termview.title')"
    :color="$vuetify.theme.themes.light.primary"
    icon="edit"
    v-if="term !== null && term !== undefined"
  >
    <v-card-text>
      <v-form :disabled="true" ref="form" v-model="valid">
        <v-container>
          <div class="row">
            <div class="col-12 col-md-12">
              <pbas-data-table
                ref="table"
                :dataProvider="provider"
                identifier="contributionsTermsDetails"
                @error="setDummyDetails"
                :showSelect="false"
              ></pbas-data-table>
            </div>
          </div>
        </v-container>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn
        text
        :disabled="loading"
        @click="
          termInternal = null;
          $emit('close');
        "
      >
        {{ $t("globals.close") }}
      </v-btn>
      <!-- <v-btn color="primary" :loading="loading" @click="save()">
        {{ $t("globals.save") }}
      </v-btn> -->
    </v-card-actions>
    <error-handler :error="error"></error-handler>
  </material-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import deepClone from "../../utils/deepClone";
import ErrorHandler from "../../components/ErrorHandler";
import { ODataProvider } from "pbas-vue-components";
import EmployerTermDetailsHeaders from "../../headers/PlanTermsDetails";
export default {
  components: {
    ErrorHandler,
  },
  props: {
    term: Object,
    store: Object,
  },
  data: () => ({
    valid: false,
    loading: false,
    error: null,
    provider: undefined,
    headers: EmployerTermDetailsHeaders,
  }),
  computed: {
    ...mapGetters("common", {
      selectedPlan: "plan",
    }),
  },
  watch: {
    term: {
      handler(val) {
        if (val !== null && val !== undefined) {
          const url = `plans/${this.selectedPlan.Id}/stores-terms/${
            this.store.Id
          }/terms/${val.Id}`;
          this.provider = new ODataProvider(this.$axiosHttp, url, this.headers);
        }
      },
      immediate: true,
    },
  },
  methods: {
    setDummyDetails() {
      this.$refs.table.fetchResult = {
        items: [
          {
            Id: "78f90027-7bde-4ca3-aa9e-ae226d74864b",
            FirstName: "John",
            LastName: "Smith",
            Certificate: "4a45a7bd-6639-419f-a984-52bfc474217e",
            EHC: 123.45,
            Dental: 234.56,
            Life: 111.11,
            LTD: 0.0,
            ADnD: 0.0,
            Total: 469.12,
          },
        ],
        count: 1,
      };
      this.$refs.table.loading = false;
    },
  },
};
</script>
